

export function getSlug({ slug }) {
  if (Array.isArray(slug)) return `/docs/${slug.join('/')}`;
  else return `/docs/${slug}`;
}

export function removeFromLast(path, key) {
  const i = path.lastIndexOf(key);
  return i === -1 ? path : path.substring(0, i);
}
function getIndicesOf(searchStr, str) {
  var searchStrLen = searchStr.length;
  if (searchStrLen === 0) {
    return [];
  }
  var startIndex = 0, index, indices = [];
  str = str.toLowerCase();
  searchStr = searchStr.toLowerCase();

  while ((index = str.indexOf(searchStr, startIndex)) > -1) {
    indices.push(index);
    startIndex = index + searchStrLen;
  }
  return indices;
}

export function replaceVideo(input) {
  let contents = input;
  //[[ embed url=https://youtu.be/iEPTlhBmwRg ]]
  const idxs = getIndicesOf('[[ embed url=', contents);
  const exdIdxs = getIndicesOf(' ]]', contents);
  let cnt = 0;

  for (let k = 0; k < idxs.length; k++) {
    const substr = contents.substr(idxs[k], exdIdxs[k] + 3 - idxs[k]);
    const start = idxs[k] + 13;
    const link = contents.substr(idxs[k] + 13, exdIdxs[k] - start).replace('watch','embed');
    console.log(substr)
    const h = `
                <div class="video-container">
                <figure class="video_container">
                <iframe width="560" height="315" src="${link}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </figure>
                </div>
            `;
    contents = contents.replace(substr, h);
    cnt++;
  }
  return contents;
}